import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-job_detail_home",
  "use": "icon-job_detail_home-usage",
  "viewBox": "0 0 35 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 36\" id=\"icon-job_detail_home\"><path d=\"M18.175 2.574c-.186-.124-.435-.164-.675-.164-.24 0-.489.04-.675.164l-14.99 9.99a.843.843 0 0 0-.335.629V34.5h8.9l.004-6.879a6.885 6.885 0 0 1 2.223-4.853c1.26-1.162 2.995-1.92 5.15-1.988a7.08 7.08 0 0 1 4.841 2.175 7.078 7.078 0 0 1 1.982 4.92v6.624l8.9.001V13.193a.846.846 0 0 0-.336-.628L18.175 2.574Z\" stroke=\"#777\" stroke-width=\"3\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol